"use client";

import type { ToolUIRegistry } from "@bg-bgi/magnus-sdk/react";
import { multipleChoiceToolRegistry } from "./tools/multiple-choice/registry";
import { weatherToolRegistry } from "./tools/weather/registry";
import { webSearchToolRegistry } from "./tools/web-search/registry";

/**
 * Server-tool views the block renders with no host wiring: every extracted
 * family (plan 030). Filtered by the provider's `builtInTools` policy and
 * merged UNDER the host's `toolViews`, so a host can override any entry.
 */
export const DEFAULT_TOOL_VIEWS = {
  ...multipleChoiceToolRegistry,
  ...weatherToolRegistry,
  ...webSearchToolRegistry,
} satisfies ToolUIRegistry;
